import React, { useState, useEffect, useRef } from "react";
import { Modal, Progress, Icon } from "semantic-ui-react";
import { QuizApi } from "../../../../api/quiz";
import "./KahootQuiz.scss";

const quizApi = new QuizApi();

export function KahootQuizModal({
  open,
  onClose,
  quiz,          // { teacherQuizId, name, questions: [...], totalTime }
  accessToken,
  studentId,
  onFinish,
}) {
  // 1) Hooks siempre al principio
  const [idx,        setIdx]        = useState(0);
  const [timeLeft,   setTimeLeft]   = useState(20);
  const [responses,  setResponses]  = useState([]);
  const [accTime,    setAccTime]    = useState(0);
  const timerRef     = useRef(null);

  // 2) Definimos handleAnswer antes del useEffect para no romper las reglas de hooks
  const handleAnswer = (selected, startTime) => {
    clearInterval(timerRef.current);
    const elapsed = (Date.now() - (startTime || Date.now())) / 1000;
    const taken   = 20 - timeLeft + elapsed;
    setAccTime(t => t + taken);
    setResponses(r => [
      ...r,
      {
        questionIndex: idx,
        selected,
        correct: selected === quiz.questions[idx].correct,
      },
    ]);

    if (idx + 1 < quiz.questions.length) {
      setIdx(idx + 1);
    } else {
      const final = [
        ...responses,
        {
          questionIndex: idx,
          selected,
          correct: selected === quiz.questions[idx].correct,
        },
      ];
      submitQuiz(final, accTime + taken);
    }
  };

  // 3) Envío final
  const submitQuiz = async (finalResponses, totalTime) => {
    try {
      await quizApi.submitStudentQuiz(accessToken, studentId, {
        teacherQuizId: quiz.teacherQuizId,
        responses: finalResponses,
        timeTaken: Math.round(totalTime),
        totalTime: quiz.totalTime,
      });
      onFinish && onFinish();
    } catch (err) {
      console.error("Error submitting quiz:", err);
    } finally {
      onClose();
    }
  };

  // 4) Effect del temporizador
  useEffect(() => {
    if (!open || !quiz?.questions?.length) return;
    setTimeLeft(20);
    const start = Date.now();
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          handleAnswer(null, start);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, quiz, idx]);

  // 5) Render condicional
  if (!open || !quiz?.questions?.length) return null;

  const current        = quiz.questions[idx];
  const totalQuestions = quiz.questions.length;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="fullscreen"
      className="kahoot-modal"
      closeIcon
    >
      <Modal.Header className="kahoot-header">
        <Icon name="question circle outline" />
        {current.question}
      </Modal.Header>
      <Modal.Content className="kahoot-content">
        <div className="kahoot-timer">
          <div className="circle">{timeLeft}</div>
        </div>
        <div className="kahoot-answers">
          {current.responses.map((resp, i) => (
            <button
              key={i}
              className={`kahoot-answer btn-${i}`}
              onClick={() => handleAnswer(resp, Date.now())}
            >
              {resp}
            </button>
          ))}
        </div>
        <Progress
          percent={Math.round(((idx + 1) / totalQuestions) * 100)}
          indicating
          className="kahoot-progress"
        />
      </Modal.Content>
    </Modal>
  );
}
